<template>
  <NavBar />
  <div class="blog-detail" v-if="post">
    <h1 class="blog-detail-title">{{ post.title }}</h1>
    <div class="blog-detail-date">{{ post.date }}</div>
    <div class="blog-detail-content" v-html="marked(mdContent)"></div>
  </div>
  <div v-else>未找到内容</div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import marked from "marked";
import NavBar from "@/components/NavBar.vue";

const route = useRoute();
const post = ref(null);
const mdContent = ref("");

onMounted(async () => {
  // 从路由query中获取文件路径和标题
  const filePath = route.query.filePath;
  const title = route.query.title;

  if (filePath) {
    post.value = {
      title: title || "未知标题",
      mdFile: filePath,
    };

    // 动态加载 md 文件
    const res = await fetch(filePath);
    mdContent.value = await res.text();
  }
});
</script>

<style scoped>
.blog-detail {
  max-width: 700px;
  margin: 40px auto;
  padding: 0 16px;
  text-align: center;
}
.blog-detail-tags {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}
.blog-tag {
  background: #f3f4f6;
  color: #888;
  font-size: 0.95rem;
  border-radius: 8px;
  padding: 2px 10px;
}
.blog-detail-title {
  font-size: 2.2rem;
  font-weight: bold;
  margin: 8px 0 8px 0;
}
.blog-detail-date {
  color: #888;
  font-size: 1.1rem;
  margin-bottom: 16px;
}
.blog-detail-img {
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  margin: 0 auto 32px auto;
  display: block;
}
.blog-detail-content {
  text-align: left;
  margin-top: 32px;
}
.blog-section {
  margin-bottom: 32px;
}
.blog-section h2 {
  font-size: 1.2rem;
  color: #222;
  margin-bottom: 8px;
}
.blog-section p {
  color: #444;
  font-size: 1.05rem;
  line-height: 1.7;
}
</style>
